const createImage = (url) =>
    new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener("load", () => resolve(image));
        image.addEventListener("error", (error) => reject(error));
        image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
        image.src = url;
    });

export default async function getCroppedImg(imageSrc, pixelCrop, format, size) {
    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // Imposta le dimensioni del canvas alle dimensioni finali desiderate
    canvas.width = size.width;
    canvas.height = size.height;

    // Calcola il rapporto di scala per adattare l'immagine croppata alle dimensioni di 'size'
    const scaleX = size.width / pixelCrop.width;
    const scaleY = size.height / pixelCrop.height;

    // Disegna l'immagine croppata sul canvas ridimensionata secondo 'size'
    ctx.drawImage(
        image,
        pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, // Coordinata e dimensioni dell'immagine sorgente (cropping)
        0, 0, size.width, size.height // Coordinata e dimensioni sul canvas (ridimensionamento)
    );

    return canvas.toDataURL(format, 0.7);
}
